<template>
  <el-dialog title="个人信息" width="360px" :visible.sync="showDialog" @close="handleClose" :modal-append-to-body="false" v-dialogDrag>
    <el-form>
      <!-- <el-form-item prop="force" v-show="false">
        <el-input type="text" v-model="passwordPolicy.isLogin"></el-input>
      </el-form-item> -->
      <el-row>
        <el-col>
          <el-form-item label="所属机构名称:">
            {{user.orgName}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="用户名:">
            {{user.userAccount}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="最近访问时间:">
            {{dateUtil.timestampToTime(user.lastAccessedTime)}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top:20px">
      <center>
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleClose">确 定</el-button>
      </center>
    </div>
  </el-dialog>
</template>

<script>
import { userInfo } from '../api/Login';
import dateUtil from '../../common/js/util';
export default {
  name: 'userInfo',
  // 组件数据对象
  data() {
    return {
      showDialog: true,
      user: []
    }
  },
  mounted() {
    this.showUserInfo();
  },
  // 组件方法集合
  methods: {
    showUserInfo() {
      userInfo().then(result => {
        if(result.code === 20000) {
          this.user = result.data;
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    handleClose() {
      this.showDialog = false;
      this.$emit('update:isVisible', this.showDialog);
    }
  }
};
</script>

<style lang="scss">
</style>
